import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import { PreviousEmploymentBadge } from '@aibees/elephant/components/previous-employment-badge';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { PersonBadges } from '@aibees/elephant/feature/person-badges';
import { useSearch } from '@aibees/shared/context';
import { classnames } from '@aibees/shared/utils';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactHeadlineProps as Props } from './types';

export const ContactHeadline = memo(({ className, sx }: Props) => {
  const { api } = usePersonReadDataContext();
  const { search } = useSearch();

  if (!api?.data?.profile?.headline) return null;

  return (
    <Styled.Wrapper
      className={classnames('ContactHeadline', className)}
      sx={mergeSx(SX.root, sx)}
    >
      <Stack gap={1}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Typography variant="body3" fontWeight={700} color="grey.700">
            Headline :
          </Typography>
          <PreviousEmploymentBadge />
        </Stack>

        {api?.isLoading ? (
          <Skeleton animation="wave" variant="rounded" />
        ) : (
          <Box>
            <LimitTypography
              value={api?.data?.profile.headline}
              wordLimit={15}
              sx={SX.description}
              variant="body4"
              fontWeight={400}
              color="grey.700"
              search={search}
            />
          </Box>
        )}
        <PersonBadges personId={api.data.id} />
      </Stack>
    </Styled.Wrapper>
  );
});

ContactHeadline.displayName = 'ContactHeadline';
